// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__QYDUh","head":"ProcedureTableInfo_head__2R7nF"};